import { render, staticRenderFns } from "./ItemsZoomModal.vue?vue&type=template&id=ffe7322e&scoped=true&"
import script from "./ItemsZoomModal.vue?vue&type=script&lang=js&"
export * from "./ItemsZoomModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemsZoomModal.vue?vue&type=style&index=0&id=ffe7322e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe7322e",
  null
  
)

export default component.exports